import { getErrorTextStyle } from '@bingads-webui-cc-react/common-styles';
import { components as Components, Mode } from '@bingads-webui-react/app-layout-container';

export const getBudgetUpdatePanelStyles = (_components, { palette }) => ({
  Layer: {
    zIndex: '1000 !important',
  },

  Panel: {
    marginTop: `${Components.header[Mode.Collapsed].height}px`,

    '& .ms-Panel-header, & .ms-Panel-content, & .ms-Panel-footerInner': {
      paddingLeft: '16px',
      paddingRight: '16px',
    },

    '& .form-group': {
      '& .form-control-container [role="alert"]': {
        ...getErrorTextStyle(),
      },
    },

    '& .ms-Panel-footer': {
      borderTop: `1px solid ${palette.neutralLight}`,
      '& .panel-buttons button': {
        marginRight: '8px',
      },
    },

    '& .react-block-ui': {
      height: '100%',
    },
  },

  BudgetOptionImpact: {
    marginLeft: 8,
    color: palette.neutralSecondary,
  },

  CustomizeInput: {
    marginTop: 4,
    marginLeft: 8,
  },

  PanelFooterInfo: {
    marginTop: -16,
    marginLeft: -16,
    marginRight: -16,
    marginBottom: 16,
  },
});
